import { Alert, Grid, Box, Typography, Divider } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const Unauthorized = () => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      minHeight="65vh">
      <Grid item xs={12} sm={10} md={7} lg={5}>
        <Box
          sx={{
            p: 4,
            borderRadius: 3,
            boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
            backgroundColor: "background.paper",
          }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 2,
            }}>
            <LockOutlinedIcon sx={{ fontSize: 48, color: "error.main" }} />
          </Box>

          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            gutterBottom>
            Acceso restringido
          </Typography>

          <Typography
            variant="body2"
            align="center"
            color="text.secondary"
            sx={{ mb: 2 }}>
            No tienes los permisos necesarios para visualizar esta sección. Si
            consideras que esto es un error, por favor comunícate con un
            administrador.
          </Typography>

          <Divider />

          <Alert
            severity="error"
            variant="standard"
            sx={{
              mt: 2,
              justifyContent: "center",
              "& .MuiAlert-message": {
                textAlign: "center",
              },
            }}>
            Error 403 – Forbidden
          </Alert>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Unauthorized;
